import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/custom-terms/{id}/unskip']['POST'];
type Input = ThisApi['params'];

const unskipCustomTerms = async ({ id }: Input): Promise<ThisApi['response']> => {
  const response = await noodleApiClient.post(`/custom-terms/${id}/unskip`);
  return response.data;
};

export default unskipCustomTerms;
